import MainLayout from './layouts/MainLayout.vue';
import Home from './pages/Home.vue';

export default {
  path: '/dashboard',
  component: MainLayout,
  children: [{
    path: '',
    component: Home,
    name: 'dashboard_index',
  }],
};
